import { render, staticRenderFns } from "./share-settlement.vue?vue&type=template&id=ed5b15ac&scoped=true&"
import script from "./share-settlement.vue?vue&type=script&lang=ts&"
export * from "./share-settlement.vue?vue&type=script&lang=ts&"
import style0 from "./share-settlement.vue?vue&type=style&index=0&id=ed5b15ac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5b15ac",
  null
  
)

export default component.exports